export default __webpack_public_path__ + "static/media/location.c2ae12d5.svg";